export const FAQ_TOPUP = {
  title: "NẠP - RÚT TIỀN",
  subItems: [
    {
      id: 'bank-account',
      title: "Nạp, rút tiền qua tài khoản ngân hàng",
      contentItems: [
        {
          id: 'cau-1',
          title: "Số dư tối thiểu trong tài khoản ngân hàng",
          content: (
            <div>
              <p className="text-gray-700">Mỗi ngân hàng có quy định về số dư tối thiểu riêng, thường là 50.000đ. Bạn vui lòng liên hệ ngân hàng để biết thêm chi tiết.</p>
              <p className="text-gray-700 mt-2">Khi thực hiện giao dịch trên GooPay bằng tiền từ tài khoản ngân hàng đã liên kết, số dư còn lại trong tài khoản ngân hàng không được thấp hơn số dư tối thiểu theo quy định. Nếu thấp hơn, giao dịch sẽ thất bại.</p>
            </div>
          )
        },
        {
          id: 'cau-2',
          title: "Cách rút tiền từ GooPay về ngân hàng đã liên kết",
          content: (
            <div>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng, chọn "Rút tiền"</p>
              <p className="text-gray-700">Bước 2: Chọn "Về ngân hàng liên kết"</p>
              <p className="text-gray-700">Bước 3: Nhập số tiền cần rút và chọn "Rút tiền"</p>
              <p className="text-gray-700">Bước 4: Chọn "Xác nhận" để hoàn tất giao dịch</p>
              <p className="text-gray-700 mt-2">Lưu ý: GooPay hiện tại MIỄN PHÍ rút tiền 10 lần/tháng, tối đa 30.000.000đ/tháng từ Ví về tài khoản ngân hàng đã liên kết.</p>
            </div>
          )
        },
        {
          id: 'cau-3',
          title: "Hạn mức nạp, rút tiền qua tài khoản ngân hàng",
          content: (
            <div>
              <p className="text-gray-700">Hạn mức nạp, rút tiền qua tài khoản ngân hàng phụ thuộc vào quy định của từng ngân hàng và trạng thái xác thực tài khoản GooPay (đã xác thực bằng thẻ/tài khoản ngân hàng hay chưa). Xem thêm tại đây.</p>
              <p className="text-gray-700 mt-2">Lưu ý: Đối với tài khoản GooPay sử dụng tiền từ tài khoản TPBank đã liên kết, hạn mức tối đa 1 giao dịch là 1.000.000đ, tối đa 1 ngày là 5.000.000đ.</p>
            </div>
          )
        },
        {
          id: 'cau-4',
          title: "Cách nạp tiền vào GooPay từ tài khoản ngân hàng đã liên kết",
          content: (
            <div>
              <p className="text-gray-700">Sau khi liên kết GooPay với tài khoản ngân hàng, bạn có thể nạp tiền trên GooPay như sau:</p>
              <p className="text-gray-700">Bước 1: Từ màn hình chính của ứng dụng, chọn "Nạp tiền vào ví"</p>
              <p className="text-gray-700">Bước 2: Chọn nguồn tiền là tài khoản ngân hàng đã liên kết</p>
              <p className="text-gray-700">Bước 3: Nhập số tiền cần nạp</p>
              <p className="text-gray-700">Bước 4: Kiểm tra thông tin giao dịch và xác nhận để hoàn tất</p>
              <p className="text-gray-700 mt-2">Lưu ý: Nạp tiền từ tài khoản ngân hàng vào GooPay hoàn toàn miễn phí.</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'atm-card',
      title: "Nạp tiền từ thẻ ATM/ Napas",
      contentItems: [
        {
          id: 'cau-5',
          title: "Tôi có thể nạp tiền từ thẻ ATM của ngân hàng nào?",
          content: (
            <div>
              <p className="text-gray-700">Hiện tại GooPay hỗ trợ nạp tiền từ thẻ ATM của các ngân hàng sau:</p>
              <p className="text-gray-700">Agribank, Techcombank, GP Bank, ABBank, Ngân hàng Quân đội (MB), Maritime Bank, HDBank, Ngân hàng Quốc dân (NCB), VIB, Viet A Bank, Ocean Bank, Bac A Bank, Lien Viet Post Bank, SeABank, Bao Viet Bank, SHB, Kien Long Bank, SCB, Nam A Bank, Public Bank, PVcom Bank, PG Bank.</p>
              <p className="text-gray-700 mt-2">Để kiểm tra danh sách cập nhật các ngân hàng phát hành thẻ ATM được chấp nhận trong ứng dụng GooPay, bạn vui lòng vào: Màn hình chính → "Nạp tiền vào ví" → "Nguồn tiền khác" → "Thẻ ATM".</p>
            </div>
          )
        },
        {
          id: 'cau-6',
          title: "Cách nạp tiền từ thẻ ATM",
          content: (
            <div>
              <p className="text-gray-700">Để thực hiện nạp tiền, bạn cần đăng ký sử dụng dịch vụ Internet Banking với ngân hàng.</p>
              <p className="text-gray-700 mt-2">Bước 1: Từ màn hình chính của ứng dụng, chọn "Nạp tiền vào Ví" → "NGÂN HÀNG CHỈ HỖ TRỢ NẠP TIỀN" → chọn logo</p>
              <p className="text-gray-700">Bước 2: Nhập số tiền cần nạp</p>
              <p className="text-gray-700">Bước 3: Kiểm tra thông tin nạp tiền và chọn "Xác nhận"</p>
              <p className="text-gray-700">Bước 4: Nhập thông tin thẻ ATM</p>
              <p className="text-gray-700">Bước 5: Nhập mã xác nhận OTP để hoàn tất</p>
              <p className="text-gray-700 mt-2">Lưu ý: Nạp tiền từ thẻ ATM vào GooPay hoàn toàn miễn phí.</p>
            </div>
          )
        }
      ]
    }
  ]
}; 